<template>
  <div>
    <validation-observer>
      <b-row class="w-100 m-0">
        <b-col class="p-0 col-12" v-if="net !== 'facebook'">
          <b-row>
            <b-col class="col-12 d-flex justify-content-center mb-2" v-if="content.content_type === 'story'">
              <div class="w-100 container-img-story">
                <b-img
                  v-if="content.image_content && !upload_file && !isVideo(content.image_content)"
                  :src="content.image_content ? content.image_content : content.content_preview_url"
                  @error="errorLoad(content.uuid)"
                  button
                  class="img-story"
                />
                <video v-else-if="content.image_content && !upload_file && isVideo(content.image_content)" :src="content.image_content ? content.image_content : ''"  @error="errorLoad(content.uuid)" controls class="img-story">

                </video>
                <input-drag-and-drop-file
                  v-else-if="!content.image_content || upload_file"
                  :data="{
                    extensions_allowed: '.jpeg, .jpg, .png, .mp4, .mov', 
                    icon: {type: 'b-icon', name: 'file-image'}, 
                    title: $t('invitation.selectDrag'), 
                    subtitle: $t('invitation.upoadVideo'),
                    min_height: '400px'
                  }"
                  @file_loaded="fileLoaded"
                  @blob_preview="saveBlowPreview"
                  
                >
                <template #metrics>
                  <b-button
                    id="msj-metrics"
                    class="button-animation mb-1"
                    variant="button-animation"
                    @click.stop="getMetrics"
                    :disabled="disabledMetricsButtonDrag"
                  >
                    <b-icon icon="graph-up" class="icon" style="font-size: 19px;" />
                  </b-button>

                  <b-popover
                    target="msj-metrics"
                    triggers="hover"
                    placement="top"
                  >
                    <template #default>
                      <div v-html="$t('campaigns.msjMetrics')"></div>
                    </template>
                  </b-popover>
                </template>

              
              </input-drag-and-drop-file>
                <div v-if="!file">
                  <b-button id="msj-change" class="button-trash" variant="button-trash" @click="upload_file = !upload_file" v-if="!is_content_new">
                    <div><feather-icon icon="ShuffleIcon" class="icon" size="21"></feather-icon></div>
                  </b-button>
                  <b-popover
                    target="msj-change"
                    triggers="hover"
                    placement="top"
                  >
                  <template #default>
                      <h4>{{ $t('campaigns.msjChange') }}</h4>
                    </template>
                  </b-popover>
                  <b-button id="msj-download" class="button-trash button-download" variant="button-trash" @click="download(content)" v-if="!upload_file && !is_content_new">
                    <div><feather-icon icon="DownloadIcon" class="icon" size="21"></feather-icon></div>
                  </b-button>
                  <b-popover
                    target="msj-download"
                    triggers="hover"
                    placement="top"
                  >
                  <template #default>
                      <h4>{{ $t('campaigns.msjDownload') }}</h4>
                    </template>
                  </b-popover>
                  <b-button
                    id="msj-metric"
                    class="button-trash button-metrics"
                    variant="button-trash"
                    v-if="!upload_file && !is_content_new"
                    @click.stop="getMetrics"
                  >
                  <b-icon icon="graph-up" class="icon" style="font-size: 19px;"/>
                  </b-button>
                  <b-popover
                    target="msj-metric"
                    triggers="hover"
                    placement="top"
                  >
                    <template #default>
                      <div v-html="$t('campaigns.msjMetrics')"></div>
                    </template>
                  </b-popover>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <!-- YouTube: video selector -->
        <b-col class="col-12 p-0" v-if="content.content_type !== 'story' && isYoutubeNetwork">
          <b-form-group :label="`${$t('campaigns.link_of')}`">
            <div v-if="selectedVideo || content.url_info" class="d-flex align-items-center border rounded p-1 mb-1">
              <!-- Thumbnail: video recién seleccionado desde el modal -->
              <b-img
                v-if="selectedVideo"
                :src="selectedVideo.thumbnailUri"
                width="100"
                height="56"
                class="mr-1 flex-shrink-0"
                style="object-fit:cover;border-radius:4px"
              />
              <!-- Thumbnail: contenido ya vinculado — muestra content_preview_url o placeholder, ambos abren el link en nueva pestaña -->
              <template v-else-if="content.url_info">
                <b-link :href="content.url_info" target="_blank" class="flex-shrink-0 mr-1">
                  <b-img
                    v-if="content.content_preview_url"
                    :src="content.content_preview_url"
                    width="100"
                    height="56"
                    style="object-fit:cover;border-radius:4px"
                  />
                  <div
                    v-else
                    style="width:100px;height:56px;background:#f0f0f0;border-radius:4px;display:flex;align-items:center;justify-content:center;"
                  >
                    <b-icon icon="youtube" style="font-size:24px;color:#FF0000;"/>
                  </div>
                </b-link>
              </template>
              <div class="flex-grow-1 overflow-hidden mr-1">
                <p class="mb-0 font-weight-bold text-truncate" style="font-size:0.875rem">
                  <template v-if="selectedVideo">{{ selectedVideo.title.value }}</template>
                  <b-link v-else-if="content.url_info" :href="content.url_info" target="_blank" class="d-block text-truncate">
                    {{ content.url_info }}
                  </b-link>
                </p>
                <small v-if="selectedVideo" class="text-muted">
                  {{ formatVideoDuration(selectedVideo.durationSecs) }} · {{ selectedVideo.views }} vistas
                </small>
              </div>
              <b-badge v-if="isVideoLinked" variant="light-primary" pill class="flex-shrink-0">
                <feather-icon icon="CheckIcon" size="11" class="mr-25"/>
                Vinculado
              </b-badge>
              <b-button v-else size="sm" variant="outline-primary" class="flex-shrink-0" @click="openVideoModal">
                Cambiar
              </b-button>
            </div>
            <b-button v-else variant="outline-primary" block @click="openVideoModal">
              <b-icon icon="youtube" class="mr-1"/>
              Seleccionar video de YouTube
            </b-button>
          </b-form-group>
        </b-col>

        <!-- YouTube: aviso de colaboración pendiente de aprobar (solo creadores) -->
        <b-col
          class="col-12 p-0 mb-1"
          v-if="isYoutubeNetwork && is_creator && content.deal && content.deal.status === 'pending' && content.deal.url_youtube_studio"
        >
          <b-alert show variant="warning" class="d-flex align-items-start mb-0 p-1">
            <feather-icon icon="AlertCircleIcon" size="18" class="mr-1 flex-shrink-0 mt-25"/>
            <div>
              <span class="d-block font-weight-bold">{{ $t('invitation.youtubePendingApprovalTitle') }}</span>
              <span class="d-block mt-25" style="font-size:0.875rem">{{ $t('invitation.youtubePendingApprovalBody') }}</span>
              <b-link :href="content.deal.url_youtube_studio" target="_blank" class="d-inline-flex align-items-center font-weight-bold mt-50">
                {{ $t('invitation.youtubePendingApprovalLink') }}
                <feather-icon icon="ExternalLinkIcon" size="12" class="ml-25"/>
              </b-link>
            </div>
          </b-alert>
        </b-col>

        <!-- Other networks: standard URL input -->
        <b-col class="col-12 p-0" v-if="content.content_type !== 'story' && !isYoutubeNetwork">
          <validation-provider rules="required">
            <b-form-group
                :label="`${$t('campaigns.link_of')}`"
                :description="''"
            >
                <b-input-group :class="`m-auto ${urlStateExpression(content.url_info) ?  'is-valid' : 'is-invalid'}`">

                  <b-input-group-prepend
                    is-text
                    :class="`${content.url_info ? 'eye-link' : ''}`"
                    >
                    <b-link
                      class="text-white a-padding-eye-icon"
                      :href="content.url_info"
                      target="_blank"
                      v-if="content.url_info"
                    >
                      <feather-icon icon="EyeIcon"/>
                    </b-link>
                    <feather-icon icon="LinkIcon" v-else/>
                  </b-input-group-prepend>
                  <b-form-input
                  :placeholder="content.content_type ? `${$t('campaigns.link_placeholder_general')}${$t(`invitation.${content.content_type}`).toLowerCase()}` : $t('campaigns.linkPlaceholder')"
                    v-model="content.url_info"
                    type="url"
                    :state="urlStateExpression(content.url_info)"
                  />
                  <b-input-group-append v-if="showMetricsButton()">
                    <b-button id="msj-metrics" variant="dark-button-custom-content-right-link-invitation" class="dark-button-custom-content-right-link-invitation"  :disabled="metricsDisabled" @click="getMetrics">{{$t('campaigns.metrics')}}</b-button>
                  </b-input-group-append>
                  <b-popover
                    target="msj-metrics"
                    triggers="hover focus"
                    placement="top"
                    v-if="!is_creator"
                  >
                  <template #default>
                    <div v-html="$t('campaigns.msjMetrics')"></div>
                  </template>
                  </b-popover>
                </b-input-group>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col class="col-12 p-0" v-if="show_date_publish">
          <validation-provider rules="required">
            <b-form-group
              :label="$t('campaigns.date_publish')"
              :description="''"
            >
              <b-form-datepicker
                :placeholder="$t('campaigns.chooseDate')"
                v-model="content.published_date"
                class="mb-2"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit'}"
                :disabled="isVideoLinked"
              ></b-form-datepicker>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col :class="`col-12 ${new_layout ? 'col-lg-12' : 'col-lg-12'} p-0`">
          <div v-if="isVideoLinked" class="form-linked-overlay">
            <form-engagements :external_form="true" :content="content" :net="net" :new_layout="new_layout" @onSubmit="onSubmit" :key="change_content"></form-engagements>
          </div>
          <form-engagements v-else :external_form="handleInvalidForm()" :content="content" :net="net" :new_layout="new_layout" @onSubmit="onSubmit" :key="change_content"></form-engagements>
        </b-col>
      </b-row>
    </validation-observer>

    <!-- YouTube video selector modal -->
    <b-modal
      v-model="show_video_modal"
      title="Seleccionar video de YouTube"
      hide-footer
      size="lg"
      scrollable
      body-class="p-0"
    >
      <div v-if="loading_videos" class="text-center py-4">
        <b-spinner variant="primary" />
        <p class="mt-2 text-muted">Cargando videos...</p>
      </div>
      <div v-else-if="videos_list.length === 0" class="text-center text-muted py-4">
        <feather-icon icon="VideoOffIcon" size="32" class="mb-2"/>
        <p>No hay videos disponibles</p>
      </div>
      <div v-else>
        <div
          v-for="video in videos_list"
          :key="video.name"
          class="d-flex align-items-center p-1 border-bottom video-list-item"
          :class="{ 'video-list-item--disabled': video.hasPaidProductPlacement }"
          @click="!video.hasPaidProductPlacement && selectVideo(video)"
        >
          <b-img
            :src="video.thumbnailUri"
            width="140"
            height="79"
            class="mr-2 flex-shrink-0"
            style="object-fit:cover;border-radius:6px"
            :style="video.hasPaidProductPlacement ? 'opacity:0.4' : ''"
          />
          <div class="flex-grow-1">
            <div class="d-flex align-items-center flex-wrap" style="gap:6px">
              <p class="mb-0 font-weight-bold" style="font-size:0.9rem;line-height:1.3">{{ video.title.value }}</p>
              <span :class="isShortVideo(video) ? 'badge-short' : 'badge-vod'">
                {{ isShortVideo(video) ? 'Short' : 'Video' }}
              </span>
            </div>
            <small class="text-muted d-block mt-1">
              {{ formatVideoDate(video.publishTime) }} · {{ formatVideoDuration(video.durationSecs) }}
            </small>
            <div class="d-flex mt-1" style="gap:12px;font-size:0.8rem;color:#6c757d">
              <span><feather-icon icon="EyeIcon" size="12" class="mr-25"/>{{ video.views }}</span>
              <span><feather-icon icon="ThumbsUpIcon" size="12" class="mr-25"/>{{ video.likes }}</span>
              <span><feather-icon icon="MessageSquareIcon" size="12" class="mr-25"/>{{ video.comments }}</span>
            </div>
            <small v-if="video.hasPaidProductPlacement" class="text-warning d-block mt-1">
              <feather-icon icon="AlertCircleIcon" size="11" class="mr-25"/>
              Ya vinculado a otra campaña
            </small>
          </div>
          <feather-icon v-if="!video.hasPaidProductPlacement" icon="ChevronRightIcon" size="18" class="ml-1 text-muted flex-shrink-0"/>
        </div>
        <div v-if="next_page_token" class="text-center p-2">
          <b-button variant="outline-secondary" size="sm" :disabled="loading_more_videos" @click="fetchMoreVideos">
            <b-spinner v-if="loading_more_videos" small class="mr-1"/>
            Cargar más videos
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="show_code_reminder" centered hide-footer hide-header size="sm" body-class="p-0" modal-class="code-reminder-modal">
      <div class="code-reminder-header">
        <feather-icon icon="XIcon" size="20" class="code-reminder-close" @click="show_code_reminder = false"/>
        <span style="font-size:1rem;font-weight:700">{{ is_creator ? '¡Ya casi está listo! 🎉' : '¡Un último paso! 🚀' }}</span>
      </div>
      <div class="text-center px-2 pb-2">
        <div style="font-size:2.5rem;line-height:1" class="mb-1">🎬</div>
        <p class="mb-1" style="font-size:0.875rem;font-weight:600;color:#5e5873">
          <template v-if="is_creator">
            Recuerda que después de guardar debes usar el <strong>código de campaña</strong> para vincular tu video correctamente. ¡Sin él no podremos conectar tu contenido! 🔗
          </template>
          <template v-else>
            Recuerda que después de guardar debes compartir el <strong>código de campaña</strong> con el creador para que pueda vincular su video. ¡No olvides enviárselo! 📩
          </template>
        </p>
        <div class="d-flex align-items-center justify-content-center mb-1" style="gap:8px">
          <span ref="code_reminder_badge" class="external-id-badge-reminder">
            {{ code_campaign }}
            <b-button variant="ml-2 flat-primary" size="sm" class="p-50" @click="copyCodeFromModal">
              <feather-icon icon="CopyIcon" size="14"/>
            </b-button>
          </span>
        </div>
        <b-button variant="primary" pill size="sm" @click="show_code_reminder = false">
          Entendido ✅
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="show_preview" centered hide-footer hide-header body-class="p-3 pt-5">
      <feather-icon
        icon="XIcon"
        size="24"
        class="icon-close"
        @click="closeModal()"
      />
      <div class="w-full d-flex justify-content-center">
        <video class="w-full" v-if="isVideoBlob(content.image_content)" controls>
          <source :src="content.image_content" type="video/mp4">
        </video>
        <b-embed
          v-else-if="isVideo(content.image_content)"
          type="iframe"
          aspect="4by3"
          :src="content.image_content"
          allowfullscreen
          class="img-story"
        ></b-embed>
        <b-img
          v-else
          :src="content.image_content ? content.image_content : ''"
          class="img-story"
        />
      </div>
      <div class="w-full d-flex justify-content-center mt-3">
        <b-button variant="success" @click="download(content)">Descargar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import manage_invitation from "@/services/invitation";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import { getThumbnails } from 'video-metadata-thumbnails';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import { getMotivationalPhrase, showToast } from "@/libs/utils/others";
import { urlStateExpression } from "@/libs/utils/urls";
import { getUserData } from '@/libs/utils/user';
import service_campaign from "@/services/campaign";

import {
  BCol,
  BRow,
  // BFormFile,
  BButton,
  // BAvatar,
  BEmbed,
  BFormGroup,
  BFormDatepicker,
  BModal,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BInputGroupPrepend,
  BLink,
  BPopover,
  BSpinner,
  BBadge,
  BAlert,
} from "bootstrap-vue";

export default {
  name: 'GeneralForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    BCol,
    BRow,
    // BFormFile,
    BButton,
    // BAvatar,
    BEmbed,
    BFormGroup,
    BFormDatepicker,
    BModal,
    BImg,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BInputGroupPrepend,
    BLink,
    BPopover,
    BSpinner,
    BBadge,
    BAlert,
    inputDragAndDropFile: () => import('@/views/components/inputs/inputDragAndDropFile.vue'),
    formEngagements: () => import('@/views/components/campaign/formEngagements.vue')
  },
  data() {
    return {
      getUserData,
      is_creator: getUserData()?.main_group?.name === 'creator',
      urlStateExpression,
      required,
      file: null,
      blob_preview: null,
      preview: '',
      show_preview: false,
      img_default: require("@/assets/images/dashboard/b1b1b1.png"),
      change_content: false,
      interval_loading: null,
      upload_file: false,
      content: {...this.content_dad},
      show_video_modal: false,
      loading_videos: false,
      loading_more_videos: false,
      videos_list: [],
      next_page_token: '',
      selectedVideo: null,
      selected_video_name: null,
      show_code_reminder: false,
    };
  },
  props: {
    uuids: {
      required: true,
      type: Object,
    },
    content_dad: {
      required: true,
      type: Object,
    },
    content_type: {
      type: String
    },
    net: {
      default: '',
      type: String,
    },
    info_add: {
      required: false,
      type: Object
    },
    snap: {
      required: false,
      type: Boolean
    },
    new_layout: {
      type: Boolean
    },
    show_date_publish: {
      type: Boolean,
      required: false,
      default: false
    },
    is_content_new: {
      type: Boolean,
      required: false,
      default: false
    },
    code_campaign: {
      type: String,
      default: null
    },
  },
  created() {
    if (this.isVideo(this.content.image_content)) {
      if (!this.content.content_preview_url) {
        const thumbnails = getThumbnails(this.content.image_content, {
          quality: 0.6
        });

        thumbnails.then((value) => {
          this.preview = URL.createObjectURL(value[0].blob)
        });
      } else {
        this.preview = this.content.content_preview_url
      }
    }
  },
  computed: {
    isYoutubeNetwork() {
      return this.net === 'youtube' && !!this.content.deal;
    },
    isVideoLinked() {
      return !!this.content.deal?.is_video_linked;
    },
    disabledMetricsButtonDrag() {
      const network_influencer = this.content.selected_influencers_network || this.content.influencer?.network;
      const username = this.content.selected_influencers || this.content.influencer?.username;
      return (
        this.is_creator ||
        !network_influencer ||
        !username ||
        !this.content.network ||
        !this.content.content_type
      );
    },
    metricsDisabled() {
      const network_influencer = this.content.selected_influencers_network || this.content.influencer?.network;
      const username = this.content.selected_influencers || this.content.influencer?.username;
      return (
        this.is_creator ||
        !network_influencer ||
        !username ||
        !this.content.network ||
        !this.content.content_type ||
        this.handleInvalidForm()
      );
    }
  },

  methods: {
    openVideoModal() {
      this.show_video_modal = true;
      if (this.videos_list.length === 0) this.fetchVideos();
    },
    fetchVideos() {
      const channel_id = this.content.deal?.creator_channel_id;
      if (!channel_id) return;
      this.loading_videos = true;
      this.next_page_token = '';
      service_campaign.getInfluencerVideos(channel_id).then(({ videos, nextPageToken }) => {
        this.videos_list = videos;
        this.next_page_token = nextPageToken;
        this.loading_videos = false;
      });
    },
    fetchMoreVideos() {
      const channel_id = this.content.deal?.creator_channel_id;
      if (!channel_id || !this.next_page_token) return;
      this.loading_more_videos = true;
      service_campaign.getInfluencerVideos(channel_id, this.next_page_token).then(({ videos, nextPageToken }) => {
        this.videos_list = [...this.videos_list, ...videos];
        this.next_page_token = nextPageToken;
        this.loading_more_videos = false;
      });
    },
    selectVideo(video) {
      this.selectedVideo = video;
      this.selected_video_name = video.name.replace('videos/', '');
      this.content.url_info = video.videoUrl;
      this.content.number_of_views = parseInt(video.views) || 0;
      this.content.number_of_likes = parseInt(video.likes) || 0;
      this.content.number_of_comments = parseInt(video.comments) || 0;
      if (video.publishTime) this.content.published_date = video.publishTime.split('T')[0];
      if (video.thumbnailUri) {
        fetch(video.thumbnailUri)
          .then(r => r.blob())
          .then(blob => {
            this.blob_preview = new File([blob], 'thumbnail.jpg', { type: blob.type || 'image/jpeg' });
          })
          .catch(() => {});
      }
      this.change_content = !this.change_content;
      this.show_video_modal = false;
      if (this.code_campaign) this.show_code_reminder = true;
    },
    copyCodeFromModal() {
      // Dentro del b-modal el foco queda atrapado: se usa la Clipboard API y, si no existe,
      // se pasa un contenedor dentro del modal para que vue-clipboard2 pueda seleccionar el texto
      const has_clipboard_api = !!(navigator.clipboard && window.isSecureContext);
      let copy = null;
      if (has_clipboard_api) copy = navigator.clipboard.writeText(this.code_campaign);
      else copy = this.$copyText(this.code_campaign, this.$refs.code_reminder_badge);
      copy.then(() => {
        loadToastificationContent().then((module) => {
          this.$toast({
            component: module.default,
            position: 'top-right',
            props: {
              title: this.$t('campaigns.copy_code_campaign_title'),
              icon: 'CopyIcon',
              text: this.$t('campaigns.share_code_campaign'),
              variant: 'success'
            }
          });
        });
      });
    },
    isShortVideo(video) {
      return video.creatorContentType === 'SHORTS';
    },
    formatVideoDuration(secs) {
      const s = parseInt(secs) || 0;
      const m = Math.floor(s / 60);
      const rem = s % 60;
      return `${m}:${rem.toString().padStart(2, '0')}`;
    },
    formatVideoDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: 'numeric' });
    },
    errorLoad(uuid_img) {
      service_campaign.getImageUpdatedContent(uuid_img).then((response) => {
        const img_new = response.image_content;
        this.content.image_content = img_new;
      });
    },
    fileLoaded(file) {
      this.file = file;
    },
    handleInvalidForm() {
      // rest of content types
      if (this.content.content_type !== 'story') {
        return !urlStateExpression(this.content.url_info)

      } else {
        // for story content type, we only if exists a file
        return !this.file && !this.content.image_content
      }
    },
    download(content) {
      const a = document.createElement('a');
      a.href = content.image_content;
      a.download = "output.png";
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    isVideoBlob(url) {
      if (url === null) return ''

      if (url.split(':')[0] === 'blob') {
        return this.file.type.split('/')[0] === 'video'
      } else {
        const split = url.split(".");
        const last_one = split[split.length - 1];
        return last_one.toLowerCase() === "mov";
      }
    },
    showVideo() {
      if (this.content.image_content) this.show_preview = true
      else this.$refs['input-file'].$refs['input'].click()
    },
    closeModal() {
      this.show_preview = false
    },
    isVideo(url) {
      if (url === null) return ''
      if (url.split(':')[0] === 'blob') {
        return this.file.type.split('/')[0] === 'video'
      } else {
        const clean = url.split('?')[0].toLowerCase();
        const ext = clean.split('.').pop();
        return ['mp4', 'mov'].includes(ext);
      }
    },
    saveBlowPreview(blob) {
      this.blob_preview = blob;
    },
    onSubmit(new_metrics) {
      const form = new FormData();
      form.append("network", this.net);
      form.append("status", "content_published");
      if (this.file) {
        form.append("image_content", this.file);
      }
      form.append("content_type", this.content.content_type);
      
      if (this.blob_preview) {
        form.append("blob_preview", this.blob_preview);
        this.$emit('send_blob_preview', this.blob_preview)
      }
      if (this.selected_video_name) {
        form.append("video_id", this.selected_video_name);
        form.append("link_video_to_deal", true);
      }
      form.append("url_info", this.content.url_info !== null ? this.content.url_info : "")

      this.content.number_of_views = new_metrics.views;
      this.content.number_of_impressions = new_metrics.impressions;
      this.content.number_of_likes = new_metrics.likes;
      this.content.number_of_times_saved = new_metrics.saved;
      this.content.number_of_shares = new_metrics.shares;
      this.content.number_of_comments = new_metrics.comments;

      form.append("number_of_views", this.content.number_of_views);
      form.append("number_of_impressions", this.content.number_of_impressions);
      form.append("number_of_likes", this.content.number_of_likes);
      form.append("number_of_times_saved", this.content.number_of_times_saved);
      form.append("number_of_shares", this.content.number_of_shares);
      form.append("number_of_comments", this.content.number_of_comments);

      if (this.show_date_publish) {
        form.append('published_date', this.content.published_date);
      } else {
        form.append("published_date", (this.info_add.date_publish !== null) ? this.info_add.date_publish : "")
      }


      if (this.is_content_new) {
        this.$emit('closeModal', { 
          ...this.content,
          image_content: this.file || null,
        })
        return
      }
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      if (this.content.uuid === undefined) {

        form.append("campaign_influencer", this.uuids.campaign_influencer)
        form.append("network", this.net)
        form.append("estimated_cost", (this.info_add.estimated_cost !== null) ? this.info_add.estimated_cost : "")
        form.append("url_info", this.content.url_info !== null ? this.content.url_info : "")

        manage_invitation.addContentNoSession(this.uuids.campaign_uuid, form).then((response) => {
          clearInterval(this.interval_loading)
          this.$vs.loading.close()
          if (!response.uuid) {
            showToast(this, 'danger', 'BellIcon', 'campaigns.error',  response.data.response.message.url_info[0], {translate_text: false});
          } else {
            this.$emit('closeModal', response)
            showToast(this, 'success', 'CheckCircleIcon', 'campaigns.contentAdd', 'campaigns.contentSuccess'); 
          }
        })

      } else {
        manage_invitation
          .updateCampaignContent(this.uuids.campaign_uuid, this.content.uuid, form)
          .then((res) => {
            clearInterval(this.interval_loading)
            this.$vs.loading.close()
            res.index = this.content.index
            this.$emit('closeModal', res);
            this.$emit('closeSidebar', res);
            this.blob_preview = null
            this.$store.commit('main_store/LINK_INVITATION_READY_TO_PAY', res.ready_to_pay)

            showToast(this, 'success', 'CheckCircleIcon', 'invitation.contentPublished');
          })
          .catch(() => {
            showToast(this, 'danger', 'BellIcon', 'campaigns.error', 'campaigns.infoFailed');
          });
      }
    },
    showMetricsButton() {
      return !(this.content_type === 'story');
    },
    showLoader() {
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
    },
    hideLoader() {
      clearInterval(this.interval_loading)
      this.$vs.loading.close()
    },
    getMetrics() {
      this.showLoader()
      const data = {
        network: this.content.selected_influencers_network ? this.content.selected_influencers_network : this.content.influencer.network,
        username: this.content.selected_influencers ? this.content.selected_influencers : this.content.influencer.username,
        network_publish: this.content.network,
        content_type: this.content.content_type,
        url: this.content.url_info
      }

      manage_invitation.getMetricsV2(data).then((response) => {
        this.hideLoader()
        if (response.status >= 400) {
          showToast(this, 'danger', 'BellIcon', 'campaigns.MetricsNotObtained', 'campaigns.notRetrieved');
        } else {
          this.content.number_of_comments = response.number_of_comments
          this.content.number_of_likes = response.number_of_likes
          this.content.number_of_shares = response.number_of_shares
          this.content.number_of_views = response.number_of_views
          this.content.number_of_impressions = response.number_of_impressions
          this.content.number_of_times_saved = response.number_of_times_saved
          this.change_content = !this.change_content;
          showToast(this, 'success', 'CheckCircleIcon', 'campaigns.capturedMetrics', 'campaigns.metricsSuccess');
        }
      });
    }
  },
  watch: {
    content_dad: {
      handler(newVal) {
        this.content = {
          ...this.content,
          ...newVal,
          url_info: this.content.url_info || newVal.url_info,
          published_date: this.content.published_date || newVal.published_date

        }
      },
      deep: true
    },
    content_type() {
      this.change_content = !this.change_content;
    }
  }
};
</script>
<style lang="scss" scoped>
.form-linked-overlay {
  position: relative;
  pointer-events: none;
  opacity: 0.6;
}
.external-id-badge-reminder {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  background: rgba(115, 103, 240, 0.08);
  color: #7367f0;
  border: 1px solid rgba(115, 103, 240, 0.25);
}
.badge-short, .badge-vod {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}
.badge-short {
  background: rgba(234, 84, 85, 0.12);
  color: #ea5455;
  border: 1px solid rgba(234, 84, 85, 0.25);
}
.badge-vod {
  background: rgba(115, 103, 240, 0.1);
  color: #7367f0;
  border: 1px solid rgba(115, 103, 240, 0.2);
}
.external-id-badge-reminder {
  display: inline-flex;
  align-items: center;
  background: rgba(115, 103, 240, 0.08);
  color: #7367f0;
  border: 1px solid rgba(115, 103, 240, 0.2);
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.video-list-item {
  transition: background-color 150ms;
  cursor: pointer;
  &:hover:not(.video-list-item--disabled) {
    background-color: #f8f9fa;
  }
  &--disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
.container-img-story {
  position: relative;
  .img-story {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 5px;
  }
  .button-trash {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: white;
    border: none;
    border-radius: 100%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background-color: #e6e6e6;
    }
    .icon {
      color: #000 !important;
      font-size: 24px;
    }
  }
  .button-download {
    top: 60px;
  }
  .button-metrics {
    top: 110px;
  }
}
</style>
<style>
.form-file {
  width: 50%;
  margin-right: 1em;
}

.disabled-success-button {
  background-color: #28c76f69 !important;
  border-color: #28c76f69 !important;
}
.disabled-success-button:active {
  background-color: #28c76f69 !important;
  border-color: #28c76f69 !important;
}
.icon-close {
  position: absolute;
  top: 10px;
  left: 10px;
  color: rgb(39, 31, 31);
  cursor: pointer;
}
.icon-close:hover {
  background-color: rgba(55, 57, 57, 0.5);
  border-radius: 50%;
  padding: 2px;
}
.cursor-pointer-file .custom-file-label {
  cursor: pointer;
}
.code-reminder-header {
  background-color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
  padding: 1em;
}
.code-reminder-close {
  display: block;
  color: rgb(155, 155, 155);
  margin: 0 0.75em 0 0;
  cursor: pointer;
  flex-shrink: 0;
}
.code-reminder-close:hover {
  background-color: rgba(219, 219, 219, 0.5);
  border-radius: 50%;
}
</style>